import type { SupportedCountry } from "@config";
import { BaseCountryAdapter } from "./base";
import type { MapSearchType } from "@repo/maps";
import type { CurrencyType } from "@repo/database";

export class CanadaAdapter extends BaseCountryAdapter {
  code: SupportedCountry = "ca";
  currency: CurrencyType = "CAD";
  areaMeasurementUnit = "imperial" as const;

  isZipCode(input: string): boolean {
    return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(input);
  }

  getLocationTypesForSegments(segments: string[]): MapSearchType[] | undefined {
    if (segments.length === 0) {
      return undefined;
    }

    switch (segments.length) {
      case 1: // state
        return ["region"];
      case 2: // state + county
        return ["district", "place", "neighborhood"];
      case 3: // state + county + city or neighborhood
        return ["place", "neighborhood"];
      default:
        return ["place", "neighborhood"];
    }
  }
}

export const ca = new CanadaAdapter();
